<template>
    <section class="shadow-[0_20px_20px_-30px]">
        <h2 class="text-lg mt-0 mb-4 font-bold uppercase text-center">{{ $t("Sponsors.Header") }}</h2>
        <div class="flex flex-wrap items-center justify-center sponsors-container">
            <template v-for="(sponsor, index) in sponsors" :key="sponsor.Id">
                <NuxtLink :to="localePath('/distributors/' + sponsor.VirtualPath)" class="h-10 m-3">
                    <EnhancedImage
                        :src="cdnUrl + sponsor.LogoUrl"
                        :alt="sponsor.Name"
                        height="40"
                        width="140"
                        css-class="max-h-[40px] max-w-[140px] w-full h-auto" />
                </NuxtLink>
                <div v-if="Math.floor(sponsors.length / 2) === index" class="lg:basis-full"></div>
            </template>
        </div>
        <div class="text-lg text-center mt-4 mb-8">
            <NuxtLink id="link-all-distributors" :external="true" :to="localePath('/distributors')">{{
                $t("Distributor.ViewAllParticipatingDistributors")
            }}</NuxtLink>
        </div>
    </section>
</template>
<script setup>
const localePath = useLangPath();
const { data: sponsors } = await useApi("home/sponsors");
const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;
</script>
